<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          User id: {{ form.id }}
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol xs="12" md="6" class="text-center py-5 d-md-down-none">
              <CCardBody>
                <img src="img/boxes.png" alt="" style="width: 100%">
              </CCardBody>
            </CCol>
            <CCol xs="12" md="6">
              <CInput
                placeholder="Nombre Comercial"
                label="Nombre Comercial"
                v-model="form.comercialname"
                required
              >
                <template #prepend-content>
                  <font-awesome-icon icon="id-badge"/>
                </template>
              </CInput>
              <CInput
                placeholder="Dirección comercial"
                label="Dirección comercial"
                v-model="form.address"
                required
              >
                <template #prepend-content>
                  <font-awesome-icon icon="location-arrow"/>
                </template>
              </CInput>
              <CInput 
                placeholder="Nombre"
                label="Nombre" 
                v-model="form.name" 
                required
              >
                <template #prepend-content>
                  <font-awesome-icon icon="id-card"/>
                </template>
              </CInput>
              <CInput
                type="email"
                label="Correo"
                placeholder="Correo"
                autocomplete="email"
                v-model="form.email"
                required
              >
                <template #prepend-content
                  ><font-awesome-icon icon="at"
                /></template>
              </CInput>
              <CInput
                type="phone"
                placeholder="Teléfono"
                label="Teléfono"
                autocomplete="phone"
                v-model="form.phone"
              >
                <template #prepend-content
                  ><font-awesome-icon icon="phone"
                /></template>
              </CInput>
              <CInput
                type="password"
                placeholder="Contraseña"
                label="Contraseña"
                autocomplete="password"
                v-model="form.password"
              >
                <template #prepend-content
                  ><font-awesome-icon icon="key"
                /></template>
              </CInput>

              <hr />
              <div class="mb-4">
                <h5>Autenticación de Dos Factores (2FA)</h5>
                <div v-if="!form.two_factor_enabled">
                  <CButton color="info" @click="generate2FA" v-if="!qrUrl">
                    <CSpinner v-if="loading2fa" variant="grow" size="sm" />
                    Configurar 2FA
                  </CButton>
                  <div v-else class="mt-3">
                    <p>Escanee este código QR con su aplicación de autenticación (ej. Google Authenticator):</p>
                    <qrcode-vue :value="qrUrl" :size="200" level="H" class="mb-3" />
                    <p>O ingrese este secreto manualmente: <strong>{{ secret }}</strong></p>
                    <CInput
                      placeholder="Código de verificación"
                      v-model="twoFactorCode"
                    >
                      <template #prepend-content><font-awesome-icon icon="shield-alt"/></template>
                    </CInput>
                    <CButton color="success" @click="enable2FA">
                      <CSpinner v-if="loading2fa" variant="grow" size="sm" />
                      Activar 2FA
                    </CButton>
                  </div>
                </div>
                <div v-else>
                  <CAlert color="success">
                    La autenticación de dos factores está habilitada.
                  </CAlert>
                  <CButton color="danger" @click="disable2FA">
                    <CSpinner v-if="loading2fa" variant="grow" size="sm" />
                    Desactivar 2FA
                  </CButton>
                </div>
              </div>
              <hr />
              <div class="mb-4">
                <h5>Sesiones Iniciadas</h5>
                <CSpinner v-if="loadingSessions" variant="grow" size="sm" />
                <CDataTable
                  v-else
                  :items="sessions"
                  :fields="sessionFields"
                  hover
                  striped
                  bordered
                  size="sm"
                  :items-per-page="5"
                  pagination
                >
                  <template #created_at="{item}">
                    <td>{{ new Date(item.created_at).toLocaleString() }}</td>
                  </template>
                  <template #last_used_at="{item}">
                    <td>{{ item.last_used_at ? new Date(item.last_used_at).toLocaleString() : 'N/A' }}</td>
                  </template>
                  <template #is_current="{item}">
                    <td>
                      <CBadge v-if="item.is_current" color="success">Actual</CBadge>
                      <span v-else></span>
                    </td>
                  </template>
                  <template #actions="{item}">
                    <td>
                      <CButton 
                        v-if="!item.is_current" 
                        color="danger" 
                        size="sm" 
                        @click="revokeSession(item.id)">
                        Finalizar
                      </CButton>
                    </td>
                  </template>
                </CDataTable>
              </div>
              <hr />
              
              <CCol col="12" sm="12" lg="12" v-show="alert.show">
                <CAlert :color="alert.color" dismissible>
                  {{ alert.message }}
                </CAlert>
              </CCol>
              <CButton color="primary" @click="save">
                <CSpinner v-if="loading" variant="grow" size="sm" />
                Guardar
              </CButton>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Resource from "@/api/resource";
import ProfileResource from "@/api/user";
import request from '@/utils/request';
import QrcodeVue from 'qrcode.vue';

const userResource = new Resource("user");
const profileResource = new ProfileResource();

export default {
  name: "User",
  components: {
    QrcodeVue
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("users");
    });
  },
  data() {
    return {
      usersOpened: null,
      loading: false,
      alert: {
        color: "danger",
        message: "",
        show: false,
      },
      form: {
        comercialname: "",
        address: "",
        name: "",
        email: "",
        phone: "",
        two_factor_enabled: false,
      },
      qrUrl: null,
      secret: null,
      twoFactorCode: '',
      loading2fa: false,
      sessions: [],
      loadingSessions: false,
      sessionFields: [
        { key: 'name', label: 'Dispositivo/App' },
        { key: 'created_at', label: 'Iniciada el' },
        { key: 'last_used_at', label: 'Último uso' },
        { key: 'is_current', label: 'Estado' },
        { key: 'actions', label: 'Acciones' }
      ],
    };
  },
  computed: {
    fields() {
      return [
        { key: "key", label: this.username, _style: "width:150px" },
        { key: "value", label: "", _style: "width:150px;" },
      ];
    },
    userData() {
      const id = this.$route.params.id;
      const user = usersData.find((user, index) => index + 1 == id);
      const userDetails = user ? Object.entries(user) : [["id", "Not found"]];
      return userDetails.map(([key, value]) => {
        return { key, value };
      });
    },
    visibleData() {
      return this.userData.filter((param) => param.key !== "username");
    },
    username() {
      return this.userData.filter((param) => param.key === "username")[0].value;
    },
    vendorVisible() {
      return (
        (this.form.role == "Distribuidor" || this.form.role == "Mayorista") &&
        (this.$store.state.user.role == "Administrador" ||
          this.$store.state.user.role == "Financiero")
      );
    },
  },
  watch: {
    "form.role": async function (newValue, oldValue) {
      if (
        newValue != oldValue &&
        newValue != null &&
        newValue != "Administrador"
      ) {
        const index = this.role.indexOf(newValue);
        let parentRole = null;
        if (index >= 0) {
          parentRole = this.role[index - 1];
          await this.getParentsByRole(parentRole);
        }
        this.showParent = parentRole != null;
      }
    },
  },
  async mounted() {
    await this.loadClient();
    await this.loadSessions();
  },
  methods: {
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/users" });
    },
    async loadClient() {
      await profileResource
        .profile()
        .then((response) => {
          this.form = response.data;
          this.loading = false;
          console.log(this.form);
        })
        .catch((error) => {
          //console.log(error);
          this.loading = false;
        });
    },
    save() {
      this.loading = true;
      userResource
        .update(this.form.id, this.form)
        .then((response) => {
          this.alert.show = true;
          this.alert.message = "Se guardó correctamente";
          this.alert.color = "success";
          this.loading = false;
        })
        .catch((error) => {
          this.alert.message = "Ocurrió un error al guardar";
          this.alert.color = "danger";
          this.loading = false;
        });
    },
    async generate2FA() {
      this.loading2fa = true;
      try {
        const response = await request({ url: '/user/2fa/generate', method: 'get' });
        this.qrUrl = response.data.qr_url;
        this.secret = response.data.secret;
      } catch (error) {
        this.alert.message = "Ocurrió un error al generar 2FA";
        this.alert.color = "danger";
        this.alert.show = true;
      } finally {
        this.loading2fa = false;
      }
    },
    async enable2FA() {
      if (!this.twoFactorCode) {
        this.alert.message = "Ingrese el código de verificación";
        this.alert.color = "warning";
        this.alert.show = true;
        return;
      }
      this.loading2fa = true;
      try {
        const response = await request({ 
          url: '/user/2fa/enable', 
          method: 'post',
          data: { code: this.twoFactorCode }
        });
        this.form.two_factor_enabled = true;
        this.alert.message = response.data.message || "2FA habilitado correctamente";
        this.alert.color = "success";
        this.alert.show = true;
      } catch (error) {
        this.alert.message = error.response && error.response.data && error.response.data.message ? error.response.data.message : "Código incorrecto";
        this.alert.color = "danger";
        this.alert.show = true;
      } finally {
        this.loading2fa = false;
      }
    },
    async disable2FA() {
      if (!confirm("¿Está seguro de que desea desactivar la Autenticación de Dos Factores?")) {
        return;
      }
      this.loading2fa = true;
      try {
        const response = await request({ url: '/user/2fa/disable', method: 'post' });
        this.form.two_factor_enabled = false;
        this.qrUrl = null;
        this.secret = null;
        this.twoFactorCode = '';
        this.alert.message = response.data.message || "2FA deshabilitado correctamente";
        this.alert.color = "success";
        this.alert.show = true;
      } catch (error) {
        this.alert.message = "Ocurrió un error al desactivar 2FA";
        this.alert.color = "danger";
        this.alert.show = true;
      } finally {
        this.loading2fa = false;
      }
    },
    async loadSessions() {
      this.loadingSessions = true;
      try {
        const response = await request({ url: '/profile/sessions', method: 'get' });
        this.sessions = response.data;
      } catch (error) {
        console.error("Error loading sessions", error);
      } finally {
        this.loadingSessions = false;
      }
    },
    async revokeSession(id) {
      if (!confirm("¿Está seguro de que desea finalizar esta sesión?")) return;
      
      try {
        await request({ url: `/profile/sessions/${id}`, method: 'delete' });
        this.alert.message = "Sesión finalizada exitosamente";
        this.alert.color = "success";
        this.alert.show = true;
        await this.loadSessions();
      } catch (error) {
        this.alert.message = "Ocurrió un error al finalizar la sesión";
        this.alert.color = "danger";
        this.alert.show = true;
      }
    },
  },
};
</script>
